import { render, staticRenderFns } from "./ShowComponents.vue?vue&type=template&id=5137dc60&scoped=true"
import script from "./ShowComponents.vue?vue&type=script&lang=js"
export * from "./ShowComponents.vue?vue&type=script&lang=js"
import style0 from "./ShowComponents.vue?vue&type=style&index=0&id=5137dc60&prod&lang=css"
import style1 from "./ShowComponents.vue?vue&type=style&index=1&id=5137dc60&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5137dc60",
  null
  
)

export default component.exports